import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ui from './ConfirmStyle';
const Confirm = {
  alert: title => {
    return confirmAlert({
      customUI: _ref => {
        let {
          onClose
        } = _ref;
        return /*#__PURE__*/React.createElement("div", {
          className: 'custom-ui',
          style: ui.controlContainer
        }, /*#__PURE__*/React.createElement("div", {
          style: ui.titleContainer
        }, /*#__PURE__*/React.createElement("div", {
          style: ui.titleLabel
        }, title), /*#__PURE__*/React.createElement("div", {
          style: ui.buttonsContainer
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            ...ui.buttonContainerOk
          }
        }, /*#__PURE__*/React.createElement("button", {
          style: {
            ...ui.buttonLabel,
            ...ui.buttonLabelOk
          },
          onClick: onClose
        }, 'OK')))));
      }
    });
  },
  success: (title, message) => {
    return confirmAlert({
      customUI: _ref2 => {
        let {
          onClose
        } = _ref2;
        return /*#__PURE__*/React.createElement("div", {
          className: 'custom-ui',
          style: ui.controlContainer
        }, /*#__PURE__*/React.createElement("div", {
          style: ui.titleContainer
        }, /*#__PURE__*/React.createElement("div", {
          style: ui.titleLabel
        }, title), /*#__PURE__*/React.createElement("div", {
          style: ui.messageContainer
        }, /*#__PURE__*/React.createElement("div", {
          style: ui.messageLabel
        }, message)), /*#__PURE__*/React.createElement("div", {
          style: ui.buttonsContainer
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            ...ui.buttonContainerOk
          }
        }, /*#__PURE__*/React.createElement("button", {
          style: {
            ...ui.buttonLabel,
            ...ui.buttonLabelOk
          },
          onClick: onClose
        }, 'OK')))));
      }
    });
  },
  confirm: (title, message, buttons, onConfirmYes) => {
    return confirmAlert({
      customUI: _ref3 => {
        let {
          onClose
        } = _ref3;
        return /*#__PURE__*/React.createElement("div", {
          className: 'custom-ui',
          style: ui.controlContainer
        }, /*#__PURE__*/React.createElement("div", {
          style: ui.titleContainer
        }, /*#__PURE__*/React.createElement("div", {
          style: ui.titleLabel
        }, title), /*#__PURE__*/React.createElement("div", {
          style: ui.messageContainer
        }, /*#__PURE__*/React.createElement("div", {
          style: ui.messageLabel
        }, message)), /*#__PURE__*/React.createElement("div", {
          style: ui.buttonsContainer
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            ...ui.buttonContainer,
            ...ui.buttonContainerLeft
          }
        }, /*#__PURE__*/React.createElement("button", {
          style: {
            ...ui.buttonLabel,
            ...ui.buttonLabelLeft
          },
          onClick: onClose
        }, buttons[1].text)), /*#__PURE__*/React.createElement("div", {
          style: {
            ...ui.buttonContainer,
            ...ui.buttonContainerRight
          }
        }, /*#__PURE__*/React.createElement("button", {
          style: {
            ...ui.buttonLabel,
            ...ui.buttonLabelRight
          },
          onClick: async () => {
            await onConfirmYes();
            onClose();
          }
        }, buttons[0].text)))));
      }
    });
  }
};
export default Confirm;
//# sourceMappingURL=Confirm.js.map